import ReIntentReasoning from './components/ReIntentReasoning';
import IntentReasoning from './components/IntentReasoning';
import Recommendclarification from './components/Recommendclarification';
import RecommendResult from './components/RecommendResult';
import RecommendReasoning from './components/RecommendReasoning';
import RecommendProcess from './components/RecommendProcess';
import AskReason from './components/AskReason';

import { Display } from '@/components/Display/Display';
const PersonalRecommend = (props) => {
    const { personal_recommend_result = {}, messageInfo = {} } = props;
    const {
        personalized_recommend_intent_reasoning = '',
        personalized_recommend_re_intent_reasoning = '',
        personalized_recommend_reasoning = '',
        personalized_recommend_process = {},
        personalized_recommend_clarification = {},
        personalized_recommend_result = {},
        personalized_recommend_ask_reason = ''
    } = personal_recommend_result || {};

    return (
        <>
            <Display show={personalized_recommend_intent_reasoning}>
                <IntentReasoning personalized_recommend_intent_reasoning={personalized_recommend_intent_reasoning}></IntentReasoning>
            </Display>
            <Display show={Object.keys(personalized_recommend_clarification).length > 0}>
                <Recommendclarification
                    messageInfo={messageInfo}
                    personalized_recommend_clarification={personalized_recommend_clarification}
                ></Recommendclarification>
            </Display>
            <Display show={Object.keys(personalized_recommend_re_intent_reasoning)}>
                <ReIntentReasoning personalized_recommend_re_intent_reasoning={personalized_recommend_re_intent_reasoning}></ReIntentReasoning>
            </Display>
            <Display show={Object.keys(personalized_recommend_process).length > 0}>
                <RecommendProcess personalized_recommend_process={personalized_recommend_process}></RecommendProcess>
            </Display>
            <Display show={personalized_recommend_reasoning}>
                <RecommendReasoning personalized_recommend_reasoning={personalized_recommend_reasoning}></RecommendReasoning>
            </Display>

            <Display show={Object.keys(personalized_recommend_result).length > 0}>
                <RecommendResult personalized_recommend_result={personalized_recommend_result}></RecommendResult>
            </Display>
            <Display show={personalized_recommend_ask_reason}>
                <AskReason personalized_recommend_ask_reason={personalized_recommend_ask_reason}></AskReason>
            </Display>
        </>
    );
};

export default PersonalRecommend;
